import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const ActualizarEstatusOrden = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.put(`/documentos/orden/estatus/${params.id}/${params.estatus}`, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        actualizarEstatusOrdenMutation: mutation.mutate,
    };
}